export const arrayAverage = (values: number[]) => {
  return values.reduce((a, b) => a + b, 0) / values.length;
};

export function shuffleArray<T>(arr: T[]) {
  return arr
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}
